module.exports = __webpack_public_path__ + "img/room_care-w.svg";